<template>
  <v-card
    flat
    class="ma-3 pa-6"
  >
    <v-row align="center" class="pl-0 mb-6 pt-3 pr-3">
      <v-card-title>
        Klachten
      </v-card-title>
      <v-spacer></v-spacer>
      <v-text-field
        v-if="false"
        outlined
        dense
        v-model="filter.query"
        placeholder="Zoek..."
        append-icon="fas fa-search"
        single-line
        hide-details
        clearable
        clear-icon="fa-times"
        @click:clear="searchKeyUp()"
        @keyup="searchKeyUp()"
      ></v-text-field>
      <v-select
        outlined
        dense
        v-model="filter.complaint_status_id"
        :items="complaintStatuses"
        item-text="name"
        item-value="id"
        single-line
        hide-details
        label="Status"
        clearable
        clear-icon="fa-times"
        style="max-width:300px"
        @change="filterChange()"
        class="ml-4"
      ></v-select>
      <v-select
        outlined
        dense
        v-model="filter.supplier_id"
        :items="suppliers"
        item-text="company_name"
        item-value="id"
        single-line
        hide-details
        label="Leverancier"
        clearable
        clear-icon="fa-times"
        style="max-width:300px"
        @change="filterChange()"
        class="ml-4"
      ></v-select>
      <v-btn
        class="ml-4"
        depressed
        color="primary"
        @click="newClick"
      >
        <v-icon
          small
          left
        >fas fa-folder-plus</v-icon>
        Nieuw
      </v-btn>
    </v-row>

    <v-data-table
      :headers="headers"
      :items="items"
      :options.sync="options"
      :server-items-length="totalCount"
      :footer-props="{ 'items-per-page-options': [5, 10, 50] }"
      :loading="isSearching"
      @click:row="rowClick"
    >

      <template v-slot:item.complaint_date="{ item }">
        {{ formatDate(item.complaint_date) }}
      </template>

    </v-data-table>

    <v-dialog
      v-model="dialog"
      max-width="1200"
      persistent
    >
      <v-card>
        <v-toolbar color="title" dark flat short class="px-2">
          <v-toolbar-title>Klacht</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn @click="dialog = false" icon><v-icon>fas fa-times</v-icon></v-btn>
        </v-toolbar>

        <v-card-text class="mt-12">

          <v-form @submit.prevent
            class="mt-6"
          >

          <v-container>
            <v-row>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="model.complaint_number"
                  outlined
                  label="Klachtnummer"
                  readonly
                  :disabled="!model.id"
                  :error-messages="errors.complaint_number"
                ></v-text-field>

                <date-picker
                  v-model="model.complaint_date"
                  :error-messages="errors.complaint_date"
                  outlined
                  label="Datum"
                ></date-picker>

                <v-select
                  v-model="model.complaint_status_id"
                  :items="complaintStatuses"
                  item-text="name"
                  item-value="id"
                  outlined
                  label="Status"
                  :error-messages="errors.complaint_status_id"
                ></v-select>
                <v-select
                  v-model="model.supplier_id"
                  :items="suppliers"
                  item-text="company_name"
                  item-value="id"
                  outlined
                  label="Leverancier"
                  :error-messages="errors.supplier_id"
                ></v-select>
              </v-col>
              <v-col cols="12" md="6">
                <CustomerField
                  label="Klant"
                  v-model="model.customer_id"
                  flat
                  outlined
                ></CustomerField>

                <v-select
                  v-model="model.offer_id"
                  :items="offers"
                  item-text="offer_number"
                  item-value="id"
                  outlined
                  clearable
                  clear-icon="fa-times"
                  label="Offerte"
                  :error-messages="errors.offer_id"
                ></v-select>
                
                <v-select
                  v-model="model.offer_line_id"
                  :items="offerLines"
                  item-text="description"
                  item-value="id"
                  outlined
                  clearable
                  clear-icon="fa-times"
                  label="Offerteregel"
                  :error-messages="errors.offer_line_id"
                ></v-select>

                <v-select
                  v-model="model.responsible_party"
                  :items="responsibleParties"
                  item-text="name"
                  item-value="name"
                  outlined
                  clearable
                  clear-icon="fa-times"
                  label="Verantwoordelijke"
                ></v-select>



              </v-col>
            </v-row>

            <div class="caption">Foto's</div>
            <v-row>
              <v-col
                cols="12"
                sm="6"
                md="2"
                v-for="index in maxPhotos"
                :key="index"
              >
                <images-field
                  v-model="model[`photo${index}_url`]"
                  label="Foto"
                ></images-field>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12">
                <v-textarea
                  v-model="model.description"
                  outlined
                  label="Probleemomschrijving"
                  :error-messages="errors.description"
                ></v-textarea>
                <v-textarea
                  v-model="model.action_taken"
                  outlined
                  label="Actie ondernomen"
                  :error-messages="errors.action_taken"
                ></v-textarea>

              </v-col>
            </v-row>

          </v-container>

          </v-form>
        </v-card-text>

        <v-card-actions class="px-6 pb-8">
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            class="px-5"
            large
            outlined
            depressed
            @click="dialog = false"
          >Annuleren</v-btn>
          <v-btn
            color="primary"
            class="px-5"
            large
            depressed
            @click="saveClick()"
          >{{ model.id ? 'Opslaan' : 'Aanmaken' }}</v-btn>
        </v-card-actions>


      </v-card>





    </v-dialog>

  </v-card>
  
</template>

<script>
import { inject, ref, getCurrentInstance, computed, watch } from 'vue'
import { debounce } from 'lodash'
import { scrollToFirstError, formatDate } from '@/utils'
import CustomerField from '@/components/CustomerField'
import { useRoute, useRouter } from 'vue-router'
import DatePicker from '@/components/DatePicker'
import ImagesField from '@/components/ImagesField.vue'

export default {
  components: {
    CustomerField,
    DatePicker,
    ImagesField,
  },
  setup(props) {
    const api = inject('api')
    const loader = inject('loader')
    const { proxy } = getCurrentInstance()

    const complaintStatuses = api.resource('complaint-statuses').collection().all()
    const suppliers = api.resource('suppliers').collection({ params: { sort: 'company_name'} }).all()

    const offerCollection = api.resource('offers').collection()
    const { items: offers } = offerCollection

    const offerLineCollection = api.resource('offer-lines').collection()
    const { items: offerLines } = offerLineCollection

    const complaintModel = api.resource('complaints').model({ debug: true })
    const { attributes: model, errors, isBusy } = complaintModel
    loader.bindRef(isBusy)

    const maxPhotos = 6

    const complaintCollection = api.resource('complaints').collection({
      params: {
        expand: 'customer,offer,offer_line,complaint_status,supplier',
      },
      rules: {
        query: 'query:company_name,contact_name,address,city',
      },
      store: true,
      debug: true,
    })

    watch(() => proxy.$route.params, (params) => {
      if (params?.resetFilter) {
        complaintCollection.clearFilter()
        complaintCollection.clearOptions()
      }
    }, { immediate: true })

    watch(() => model.value.customer_id, customerId => {
      if (customerId) {
        offerCollection.setFilter('customer_id', customerId)
        offerCollection.all()
      } else {
        offerCollection.populate([])
        complaintModel.setAttribute('offer_id', null)
      }
    }, { immediate: true })

    watch(() => model.value.offer_id, offerId => {
      if (offerId) {
        offerLineCollection.setFilter('offer_id', offerId)
        offerLineCollection.all()
      } else {
        offerLineCollection.populate([])
        complaintModel.setAttribute('offer_line_id', null)
      }
    }, { immediate: true })
    

    const { items, filter, totalCount, options, isSearching } = complaintCollection

    const headers = [
      { text: 'Datum', value: 'complaint_date' },
      { text: 'Leverancier', value: 'supplier.company_name' },
      { text: 'Klant', value: 'customer.contact_name' },
      { text: 'Klacht Nr', value: 'complaint_number' },
      { text: 'Product', value: 'offer_line.description' },
      { text: 'Verantwoordelijke', value: 'responsible_party' },
      { text: 'Status', value: 'complaint_status.name' },
    ]

    const responsibleParties = [
      { name: 'Leverancier' },
      { name: 'Atelier' },
      { name: 'Intern' },
    ]

    const dialog = ref(false)



    function newClick() {
      complaintModel.clear()
      complaintModel.setAttribute('complaint_status_id', 1)
      dialog.value = true
    }

    function rowClick(item) {
      complaintModel.find(item.id).then(() => {
        dialog.value = true
      })
    }

    function saveClick() {
      complaintModel.save().then(() => {
        complaintCollection.search()
        dialog.value = false
      }).catch(() => {
        scrollToFirstError()
      })
    }

    const filterChange = complaintCollection.search
    const searchKeyUp = debounce(complaintCollection._search, 300)

    const selected = ref([])

    return {
      selected,
      headers,
      items,
      filter,
      searchKeyUp,
      filterChange,
      totalCount,
      options,
      isSearching,
      formatDate,
      newClick,
      rowClick,
      saveClick,
      dialog,
      model,
      errors,
      complaintStatuses,
      suppliers,
      offers,
      offerLines,
      maxPhotos,
      responsibleParties,
    }

  },
}
</script>


<style scoped>

::v-deep .v-data-table table tbody tr:not(.v-data-table__empty-wrapper):hover {
  cursor: pointer;
}

</style>
